import { render, staticRenderFns } from "./Kuwa.vue?vue&type=template&id=56e44df0&"
import script from "./Kuwa.vue?vue&type=script&lang=js&"
export * from "./Kuwa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports